import React, { useEffect } from "react";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

type PasswordInputProps = {
  value: string;
  label: string;
  onChange?: (event: { target: { name: string; value: string } }) => void;
  onSubmit?: () => void;
  name?: string;
  error?: string;
  onKeyDown?: any;
};

export function PasswordInput({
  label,
  onChange,
  onSubmit,
  value,
  error,
  ...other
}: PasswordInputProps): JSX.Element {
  const [password, setPassword] = React.useState<string>("");
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event?.target?.value);
    if (onChange) onChange(event);
  };

  useEffect(() => {
    value && setPassword(value + "");
  }, [value]);

  return (
    <FormControl
      className="phone-from-control"
      fullWidth
      onKeyDown={(e) => {
        if (onSubmit && e.key === "Enter") {
          e.preventDefault();
          onSubmit();
        }
      }}
    >
      <InputLabel
        error={!!error}
        htmlFor="formatted-text-mask-input"
        className="font-yekan-heavy"
      >
        {label}
      </InputLabel>

      <OutlinedInput
        label={"رمز عبور"}
        error={!!error}
        autoFocus
        {...other}
        value={value || password}
        onChange={handleChange}
        className="font-sans"
        type={showPassword ? "text" : "password"}
        sx={{
          ".MuiInputBase-input": {
            direction: "rtl",
            textAlign: "right",
          },
        }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="start"
            >
              {showPassword ? (
                <VisibilityOff fontSize="small" />
              ) : (
                <Visibility fontSize="small" />
              )}
            </IconButton>
          </InputAdornment>
        }
        startAdornment={
          <InputAdornment position="start">
            <i className="fa-regular fa-lock"></i>
          </InputAdornment>
        }
      />

      {!!error && (
        <FormHelperText sx={{ mt: 1.5, ml: 0 }} error={!!error}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
}
